<div class="gcontainer bwhite">
  <div class="row breadcrumb-header align-items-center sticky-header">
    <div class="col-md-4">
      <nav aria-label="breadcrumb" class="mt-8">
        <ol class="breadcrumb">
          <li
            class="breadcrumb-item active breadcrumb cursor"
            aria-current="page"
            (click)="reDirectUrl()"
            tabindex="0">
            Dashboard
          </li>
          @if (worksheetRecords) {
            <li class="breadcrumb-item active" aria-current="page">
              {{ worksheetRecords.company.name }} -  {{ worksheetRecords.project.projectName }}
            </li>
          }
          </ol>
        </nav>
      </div>
      <div class="col-md-8 d-flex justify-content-end align-items-center gap-2">
        <button
          mat-raised-button
          (click)="printTargetWeights()">
          Print Target Weights
        </button>
        <!-- PRINT -->
        <button
          mat-raised-button
          class="print-btn"
          (click)="export()"
          matTooltip="Print">
          <mat-icon>print</mat-icon>
          <span class="print-text">PRINT</span>
        </button>
        <!-- SAVE -->
        <button
          mat-raised-button
          color="primary"
          (click)="saveTable()">
          Save Table
        </button>
        <!-- ACTIONS -->
        <button
          mat-raised-button
          color="primary"
          [matMenuTriggerFor]="headerMenu">
          ACTIONS
        </button>
        <mat-menu #headerMenu="matMenu">
          <button mat-menu-item (click)="viewSubmissionForm()">
            <mat-icon>visibility</mat-icon>
            <span>View Submission Form</span>
          </button>
          @if (isTestingCompleted() && !hasUnsavedChanges) {
            <button mat-menu-item (click)="completeWorksheet()">
              <mat-icon>task_alt</mat-icon>
              <span>Complete Worksheet</span>
            </button>
          }
          @if (roleCheck(['Manager','Admin'])) {
            <button
              mat-menu-item
              (click)="downloadTRWorksheet()"
              >
              <img src="/assets/icons/File.svg" width="16" class="mr-8" />
              Download TR Worksheet
            </button>
          }

          @if (roleCheck(['Manager','Admin'])) {
            <button
              mat-menu-item
              (click)="downloadWorksheetReport()"
              >
              <img src="/assets/icons/File.svg" width="16" class="mr-8" />
              Download Report
            </button>
          }
        </mat-menu>
      </div>
    </div>

    <!-- HEADER CARD -->
    <mat-card class="bsmokewhite">
      <mat-card-content>
        <div class="row">
          <div class="col-md-1 worksheet-header-column-first">
            <h1 class="mat-h1">Pre Cast</h1>
          </div>
          <div class="col-md-1 worksheet-header-column-middle">
            <div class="pr-32">
              @if (worksheetRecords) {
                <span
                  class="mat-header-data"
                  >
                  {{ worksheetRecords.project.referenceId }}
                </span>
              }
            </div>
            <mat-label class="mat-header-subtitle">Reference</mat-label>
          </div>
          <div class="col-md-2 worksheet-header-column-middle">
            <div class="pr-32">
              @if (worksheetRecords) {
                <span
                  class="mat-header-data word-break-anyware"
                  >
                  {{ worksheetRecords.company.name || '-'}}
                </span>
              }
            </div>
            <mat-label class="mat-header-subtitle">Customer</mat-label>
          </div>
          <div class="col-md-3 worksheet-header-column-middle">
            <div class="pr-32">
              @if (worksheetRecords) {
                <span
                  class="mat-header-data word-break-anyware"
                  >
                  {{ worksheetRecords.project.projectName }}
                </span>
              }
            </div>
            <mat-label class="mat-header-subtitle">Project Name</mat-label>
          </div>
          <div class="col-md-1 worksheet-header-column-middle">
            <div class="pr-32">
              @if (worksheetRecords) {
                <span
                  class="mat-header-data word-break-anyware"
                  >
                  {{ worksheetRecords.project.projectNumber || '-'}}
                </span>
              }
            </div>
            <mat-label class="mat-header-subtitle">Project Number</mat-label>
          </div>
          <div class="col-md-1 worksheet-header-column-middle">
            <div class="pr-32">
              @if (worksheetRecords) {
                <span
                  class="mat-header-data"
                  >
                  {{ worksheetRecords.project.storageCompartment || '-' }}
                </span>
              }
            </div>
            <mat-label class="mat-header-subtitle">Storage Location</mat-label>
          </div>
          <div class="col-md-1 worksheet-header-column-middle">
            <div class="pr-32">
              @if (worksheetRecords) {
                <span
                  class="mat-header-data"
                  >
                  {{ worksheetRecords.project.sampleReceivedDate
                  ? (worksheetRecords.project.sampleReceivedDate | utcToLocal:'date')
                  : '-' }}
                </span>
              }
            </div>
            <mat-label class="mat-header-subtitle">Samples Received</mat-label>
          </div>
          <div class="col-md-1 worksheet-header-column-last">
            <div class="pr-32">
              @if (worksheetRecords) {
                <span
                  class="mat-header-data"
                  >
                  {{ worksheetRecords.project.dueDate
                  ? (worksheetRecords.project.dueDate | utcToLocal:'date')
                  : '-' }}
                </span>
              }
            </div>
            <mat-label class="mat-header-subtitle">Due Date</mat-label>
          </div>
          <div class="col-md-1 d-flex justify-content-end">
            <div class="days-badge" [ngClass]="{'danger': (daysLeft) < 10,'normal': (daysLeft) >= 10}">
              <span class="days-value">
                {{ daysLeft }}
              </span>
              <span class="days-label">Days</span>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <div class="row middle-header">
      <!-- Notes section -->
      <div class="col-md-11 d-flex justify-content-start flex-wrap gap-3">
        <div>
          <div class="row">
            @if (note) {
              <div>
                <mat-label class="mat-subtitle-2 bold-title">
                  @if (note.updatedBy) {
                    <span class="d-inline">
                      {{ note.updatedBy.firstName }} {{ note.updatedBy.lastName }}:
                    </span>
                  }
                  @if (note.createdAt) {
                    <span class="d-inline">
                      {{ note.createdAt | utcToLocal: 'date' }}
                      {{ note.createdAt | utcToLocal: 'time' }}
                    </span>
                  }
                </mat-label>
              </div>
            }

            @if (!note) {
              <div style="min-height: 60px">
                <p class="note-text truncate-label">No Notes Available.</p>
              </div>
            }
          </div>
          <div class="row">
            @if (note) {
              <span
                class="note-text mat-subtitle-2"
                matTooltipClass="my-custom-tooltip"
                #tooltip="matTooltip"
                [matTooltip]="note.text">
                {{ noteText }}
              </span>
            }
          </div>
          <div class="row">
            <div class="d-flex justify-content-start flex-wrap gap-3">
              <a class="link-text-data" (click)="openViewNotesDialog()" href="javascript:void(0);">
                <img src="../../../../assets/icons/New Window.svg" />
                Notes
              </a>
              <a class="link-text-data" (click)="openViewInstructionsDialog()" href="javascript:void(0);">
                <img src="../../../../assets/icons/New Window.svg" />
                Instructions
              </a>
              <app-customer-attachments
                class="worksheet-attachements"
                [projectId]="projectId"
                [backgroundClass]="'gray'"
                [showSuccess]="false">
              </app-customer-attachments>
            </div>
          </div>
        </div>
        <!-- OVEN DATE, Wet Test Data, Dry Test Data section -->
        <div>
          <div class="test-data-text d-flex align-items-center gap-2">
            <div class="edit-icon-wrapper clickable-row"
              (click)="openProjectDetailsComponent('Oven Date', 'ovenDate')">
              <img class="edit-icon" src="../../../../assets/icons/Edit.svg" />
              <span class="link-text-custom">
                Oven Date {{ worksheetRecords?.project?.ovenDate ? ': ' + worksheetRecords?.project?.ovenDate : '' }}
              </span>
            </div>
          </div>

          <div class="test-data-text d-flex align-items-center gap-2">
            <div class="edit-icon-wrapper clickable-row"
              (click)="openProjectDetailsComponent('Wet Test Data', 'wetTestData')">
              <img class="edit-icon" src="../../../../assets/icons/Edit.svg" />
              <span class="link-text-custom">
                Wet Test Data {{ worksheetRecords?.project?.wetTestData ? ': ' + worksheetRecords?.project?.wetTestData : '' }}
              </span>
            </div>
          </div>

          <div class="test-data-text d-flex align-items-center gap-2">
            <div class="edit-icon-wrapper clickable-row"
              (click)="openProjectDetailsComponent('Dry Test Data', 'dryTestData')">
              <img class="edit-icon" src="../../../../assets/icons/Edit.svg" />
              <span class="link-text-custom">
                Dry Test Data {{ worksheetRecords?.project?.dryTestData ? ': ' + worksheetRecords?.project?.dryTestData : '' }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-1 d-flex flex-column align-items-end gap-1">
        @if (worksheetRecords?.project?.geothermField) {
          <mat-chip class="chipset-green">
            <span class="text-white chip-text">Geotherm Field Test</span>
          </mat-chip>
        }

        @if (worksheetRecords?.project?.preApproval) {
          <mat-chip class="chipset-blue">
            <span class="text-white chip-text">Pre-Approval</span>
          </mat-chip>
        }

        @if (worksheetRecords?.project?.rushTesting) {
          <mat-chip class="chipset-warning">
            <img src="./../../../assets/icons/rush-warning-icon.svg" class="icon-position" />
            <span class="chip-text">Rush</span>
          </mat-chip>
        }
      </div>
    </div>

    <!-- MAT TABLE -->
    <div class="row mt-3">
      <div class="col-12">
        <table
          mat-table
          [dataSource]="dataSource"
          class="material-table custom-table"
          cdkDropList
          [cdkDropListDisabled]="dragDisabled"
          (cdkDropListDropped)="onDrop($event)">
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="masterToggle()"
                [checked]="isAllSelected()"
                [indeterminate]="isIndeterminate()"
                tabindex="-1">
              </mat-checkbox>
            </th>

            <td mat-cell *matCellDef="let row"
              (click)="$event.stopPropagation()">

              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="toggleSelection(row)"
                [checked]="selection.isSelected(row)"
                tabindex="-1">
              </mat-checkbox>
            </td>
          </ng-container>

          <!-- In-House Id Column -->
          <ng-container matColumnDef="inHouseId">
            <th mat-header-cell *matHeaderCellDef>In-House Id</th>
            <td mat-cell *matCellDef="let element">{{ element.inHouseId }}</td>
          </ng-container>

          <!-- Sample ID Column -->
          <ng-container matColumnDef="sampleId">
            <th mat-header-cell *matHeaderCellDef>Sample Id</th>
            <td mat-cell [matTooltip]="getSampleIdWithTruckandTicket(element)" *matCellDef="let element">{{ element.sampleId }}</td>
          </ng-container>

          <!-- Cast Date Column -->
          <ng-container matColumnDef="castDate">
            <th mat-header-cell *matHeaderCellDef>Cast Date</th>
            <td mat-cell *matCellDef="let element">
              {{ formatCastDate(element.castDate) }}
            </td>
          </ng-container>

          <!-- Sample Type Column -->
          <ng-container matColumnDef="sampleType">
            <th mat-header-cell *matHeaderCellDef>Sample Type</th>
            <td mat-cell *matCellDef="let element">
              {{ element.sampleType }}
            </td>
          </ng-container>

          <!-- Mix Design Column -->
          <ng-container matColumnDef="mixDesign">
            <th mat-header-cell *matHeaderCellDef>Mix Design</th>
            <td mat-cell *matCellDef="let element">
              <a href="javascript:void(0)" class="mix-link" (click)="onMixDesignClick(element)">
                {{ element.mixDesignCode }}

                @if (element.mixReference) {
                  <mat-icon
                    class="reference-icon"
                    matTooltip="Mix Reference Linked">
                    link
                  </mat-icon>
                }
              </a>
            </td>
          </ng-container>

          <!-- Sample Tare Column -->
          <ng-container matColumnDef="tare">
            <th mat-header-cell *matHeaderCellDef>Tare</th>
            <td mat-cell *matCellDef="let element" class="cell-stack">
              <input
                type="number"
                matInput [(ngModel)]="element.tare" class="table-input"
                (ngModelChange)="updateCalculations(element)"
                (focus)="onFocusClearZero(element, 'tare')"
                (blur)="onBlurRestoreZero(element, 'tare')"
                (keydown)="onSingleFieldKeyPress($event, element, 'tare')"
                (wheel)="preventNumberInputChange($event)"
                #cellInput
                [attr.data-row-id]="element.id"
                [attr.data-type]="'tare'"/>
              </td>
            </ng-container>

            <!-- Sample Mould WeightColumn -->
            <ng-container matColumnDef="mouldWeight">
              <th mat-header-cell *matHeaderCellDef>Mould Weight</th>
              <td mat-cell *matCellDef="let element">
                <input
                  type="number"
                  matInput
                  [(ngModel)]="element.mould"
                  class="table-input"
                  (ngModelChange)="updateCalculations(element)"
                  (focus)="onFocusClearZero(element, 'mould')"
                  (blur)="onBlurRestoreZero(element, 'mould')"
                  (keydown)="onSingleFieldKeyPress($event, element, 'mould')"
                  (wheel)="preventNumberInputChange($event)"
                  #cellInput
                  [attr.data-row-id]="element.id"
                  [attr.data-type]="'mould'"
                  />
                </td>
              </ng-container>

              <!-- Sample Diameter Column -->
              <ng-container matColumnDef="sampleDiameter">
                <th mat-header-cell *matHeaderCellDef>Sample Diameter</th>
                <td mat-cell *matCellDef="let element">
                  <input
                    type="number"
                    matInput
                    [(ngModel)]="element.sampleDiameter"
                    class="table-input"
                    (ngModelChange)="updateCalculations(element)"
                    (focus)="onFocusClearZero(element, 'sampleDiameter')"
                    (blur)="onBlurRestoreZero(element, 'sampleDiameter')"
                    (keydown)="onSingleFieldKeyPress($event, element, 'sampleDiameter')"
                    (wheel)="preventNumberInputChange($event)"
                    #cellInput
                    [attr.data-row-id]="element.id"
                    [attr.data-type]="'sampleDiameter'"
                    />
                  </td>
                </ng-container>

                <!-- Sample Height Column -->
                <ng-container matColumnDef="sampleHeight">
                  <th mat-header-cell *matHeaderCellDef>Sample Height</th>
                  <td mat-cell *matCellDef="let element">
                    <input
                      type="number"
                      matInput
                      [(ngModel)]="element.sampleHeight"
                      class="table-input"
                      (ngModelChange)="updateCalculations(element)"
                      (focus)="onFocusClearZero(element, 'sampleHeight')"
                      (blur)="onBlurRestoreZero(element, 'sampleHeight')"
                      (keydown)="onSingleFieldKeyPress($event, element, 'sampleHeight')"
                      (wheel)="preventNumberInputChange($event)"
                      #cellInput
                      [attr.data-row-id]="element.id"
                      [attr.data-type]="'sampleHeight'"
                      />
                    </td>
                  </ng-container>

                  <!-- Wet + Tare Column -->
                  <ng-container matColumnDef="wetPlusTare">
                    <th mat-header-cell *matHeaderCellDef>W + T</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.wetPlusTare }}
                    </td>
                  </ng-container>

                  <!-- Dry + Tare Column -->
                  <ng-container matColumnDef="dryPlusTare">
                    <th mat-header-cell *matHeaderCellDef>D + T</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.dryPlusTare }}
                    </td>
                  </ng-container>

                  <!-- Dry Weight Column -->
                  <ng-container matColumnDef="dryWeight">
                    <th mat-header-cell *matHeaderCellDef>Dry Weight</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.dryWeight }}
                    </td>
                  </ng-container>

                  <!-- Volume Column -->
                  <ng-container matColumnDef="volume">
                    <th mat-header-cell *matHeaderCellDef>Volume</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.volume }}
                    </td>
                  </ng-container>

                  <!-- Density Column -->
                  <ng-container matColumnDef="density">
                    <th mat-header-cell *matHeaderCellDef>Density</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.density }}
                    </td>
                  </ng-container>

                  <!-- Assigned To Column -->
                  <ng-container matColumnDef="assignedTo">
                    <th mat-header-cell *matHeaderCellDef>Assigned To</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.assignedTo ?? '' }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>Status</th>

                    <td mat-cell *matCellDef="let element">
                      @if (calculateRowStatus(element)) {
                        <img
                          src="../../../../assets/icons/Check.svg" />
                      }

                      @if (!calculateRowStatus(element)) {
                        <img
                          src="../../../../assets/icons/table icon.svg" />
                      }
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="testNo">
                    <th mat-header-cell *matHeaderCellDef>Test#</th>
                    <td mat-cell *matCellDef="let element">
                      @for (testResult of element.preCastWorkSheetTestResults; track testResult) {
                        <div class="test-result-row"
                          >
                          <button
                            mat-raised-button
                            type="button"
                            class="delete-btn square-btn"
                            tabindex="-1"
                            [ngClass]="getTestStatusClass(testResult)"
                            (click)="removeTestResult(element, element.preCastWorkSheetTestResults.indexOf(testResult))">
                            x
                          </button>
                          <span class="cell-text">
                            {{ testResult.testNumber }}
                          </span>
                        </div>
                      }
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="weight">
                    <th mat-header-cell *matHeaderCellDef>Weight</th>
                    <td mat-cell *matCellDef="let element">
                      @for (testResult of element.preCastWorkSheetTestResults; track testResult; let i = $index) {
                        <div class="test-result-row">
                          <input
                            matInput
                            type="number"
                            [(ngModel)]="testResult.weight"
                            class="table-input"
                            #cellInput
                            [attr.data-row-id]="element.id"
                            [attr.data-test-index]="i"
                            (keydown)="onCellKeyPress($event, element, i, 'weight')"
                            [attr.data-type]="'weight'"
                            (ngModelChange)="updateCalculations(element)"
                            (focus)="onFocusClearZero(testResult, 'weight')"
                            (blur)="onBlurRestoreZero(testResult, 'weight')"
                            (wheel)="preventNumberInputChange($event)"
                            />
                          </div>
                        }
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="loss">
                      <th mat-header-cell *matHeaderCellDef>loss</th>
                      <td mat-cell *matCellDef="let element">
                        @for (testResult of element.preCastWorkSheetTestResults; track testResult) {
                          <div class="test-result-row">
                            {{ testResult.loss }}
                          </div>
                        }
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="tr">
                      <th mat-header-cell *matHeaderCellDef>TR</th>
                      <td mat-cell *matCellDef="let element">
                        @for (testResult of element.preCastWorkSheetTestResults; track testResult; let i = $index) {
                          <div class="test-result-row">
                            <input matInput type="number" [(ngModel)]="testResult.tr" class="table-input"
                              (focus)="onFocusClearZero(testResult, 'tr')"
                              (blur)="onBlurRestoreZero(testResult, 'tr')"
                              (keydown)="onCellKeyPress($event, element, i, 'tr')"
                              (ngModelChange)="updateCalculations(element)"
                              (wheel)="preventNumberInputChange($event)"
                              [attr.data-type]="'tr'"
                              #cellInput
                              [attr.data-row-id]="element.id"
                              [attr.data-test-index]="i"
                              />
                            </div>
                          }
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="moisture">
                        <th mat-header-cell *matHeaderCellDef>Moisture</th>
                        <td mat-cell *matCellDef="let element">
                          @for (testResult of element.preCastWorkSheetTestResults; track testResult) {
                            <div class="test-result-row">
                              {{ testResult.moisture }}
                            </div>
                          }
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="addTestResult">
                        <th mat-header-cell *matHeaderCellDef>
                          <button
                            mat-raised-button
                            type="button"
                            class="square-btn"
                            (click)="addTestResultToAll()">
                            +
                          </button>
                        </th>
                        <td mat-cell *matCellDef="let element">
                          <button
                            mat-raised-button
                            type="button"
                            class="square-btn"
                            tabindex="-1"
                            (click)="addTestResult(element)">
                            +
                          </button>
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">

                          <button mat-icon-button [matMenuTriggerFor]="menu" tabindex="-1">
                            <mat-icon>more_vert</mat-icon>
                          </button>

                          <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="openAssignToDialog(element)">
                              <span class="menu-text">
                                <img src="/assets/icons/User-multiple.svg" alt="Assign" />
                                &nbsp; Assign To
                              </span>
                            </button>
                          </mat-menu>
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="sort" stickyEnd>
                        <th mat-header-cell *matHeaderCellDef class="header-text" [ngClass]="{'hidden-column': shouldHideSortColumn()}"></th>
                        <td mat-cell *matCellDef="let row" [ngClass]="{'hidden-column': shouldHideSortColumn()}">
                          @if (roleCheck(['Manager', 'Admin']) && !row.groupOrder) {
                            <button
                              (mousedown)="enableDrag()"
                              mat-icon-button>
                              <mat-icon class="dragCursor">drag_indicator</mat-icon>
                            </button>
                          }
                        </td>
                      </ng-container>

                      <!-- Header Row -->
                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

                      <!-- Data Row -->
                      <tr
                        mat-row
                        [class.bold-bottom-border]="isLastRowOfSample(row, i)"
                        *matRowDef="let row; let i = index; columns: displayedColumns;"
                        cdkDrag
                        [cdkDragDisabled]="row.groupOrder !== 0"
                        [cdkDragData]="row">
                      </tr>

                    </table>
                  </div>
                </div>
              </div>